export const REPORT_PERMISSION = {
    PAYMENT_INVOICES_VIEW: 'PAYMENT_INVOICES_VIEW',
    BUDGET_MANAGEMENT_VIEW: 'BUDGET_MANAGEMENT_VIEW',
    ADS_CONSOLE_AUDIENCE_REPORT: 'ADS_CONSOLE_AUDIENCE_REPORT',
    ADS_CONSOLE_CONTEXTUAL_REPORT: 'ADS_CONSOLE_CONTEXTUAL_REPORT',
    ADS_CONSOLE_CONTEXTUAL_VIDEO_REPORT: 'ADS_CONSOLE_CONTEXTUAL_VIDEO_REPORT',
    ADS_CONSOLE_CATEGORY_REPORT: 'ADS_CONSOLE_CATEGORY_REPORT',
    ADS_CONSOLE_PIXEL_CATEGORY_REPORT: 'ADS_CONSOLE_PIXEL_CATEGORY_REPORT',
    REP_BREAKDOWN_VIEW: 'REP_BREAKDOWN_VIEW',
    ADS_CONSOLE_OS_VERSION_REPORT: 'ADS_CONSOLE_OS_VERSION_REPORT',
    ADS_CONSOLE_OS_FAMILY_REPORT: 'ADS_CONSOLE_OS_FAMILY_REPORT',
    ADS_CONSOLE_BROWSER_REPORT: 'ADS_CONSOLE_BROWSER_REPORT',
    ADS_CONSOLE_CITY_REPORT: 'ADS_CONSOLE_CITY_REPORT',
    ADS_CONSOLE_DMA_REPORT: 'ADS_CONSOLE_DMA_REPORT',
    ADS_CONSOLE_QUARTILE_REPORT: 'ADS_CONSOLE_QUARTILE_REPORT',
    ADS_CONSOLE_VIDEO_CAMPAIGNS: 'ADS_CONSOLE_VIDEO_CAMPAIGNS',
    CAMPAIGN_BY_ADVERTISER_DOMAIN_VIEW: 'CAMPAIGN_BY_ADVERTISER_DOMAIN_VIEW',
    CAMPAIGN_BY_ATTRIBUTION_GROUP_VIEW: 'CAMPAIGN_BY_ATTRIBUTION_GROUP_VIEW',
    CAMPAIGN_SUMMARY_BY_SITE: 'CAMPAIGN_SUMMARY_BY_SITE',
    SP_VIEW_SUBCOUNTRY_PERFORMANCE: 'SP_VIEW_SUBCOUNTRY_PERFORMANCE',
    REALIZE_PIXEL_TESTER_SCREEN: 'REALIZE_PIXEL_TESTER_SCREEN',
    CAMPAIGN_HISTORY_VIEW: 'CAMPAIGN_HISTORY_VIEW',
    ADS_CONSOLE_CUSTOM_CONTEXTUAL: 'ADS_CONSOLE_CUSTOM_CONTEXTUAL',
    TA_CAMPAIGN_GROUP_REAL_TIME_REPORT: 'TA_CAMPAIGN_GROUP_REAL_TIME_REPORT',
    PUSH_API_VIEW: 'PUSH_API_VIEW',
};
